<section class="record">
    <span ng-click="toggleDetails()">
        <span class="details-toggle" ng-class="{open:showDetails}"><i class="fa fa-angle-right"></i></span>
        <span c-activity-log-blurb activity="activity"></span> {{message}}
    </span>
</section>
<section class="details" c-toggle="showDetails">
    <section class="recipients-section">
        <span ng-show="userNames.length !== 0">{{recipientsLabel}}:</span>
        <ul>
            <li class="user" ng-repeat="userName in userNames track by $index">{{userName}}</li>
        </ul>
    </section>
    <section class="message-section" c-activity-log-message activity="activity"></section>
</section>